export interface IPendingCounts {
  pendingInvoices: number;
  pendingNirlatGiftOrders: number;
  pendingPosts: number;
  pendingBusinessSales: number;
  pendingJobs: number;
}
